module.exports = __webpack_public_path__ + "static/ar-logo100-web-white-57807fc23be125bb16587c741ed05ec7.svg";